export default __webpack_public_path__ + "1811dcbc98c3962d96a1b7421eb71ea7.png";